export { default } from './Button'


// WEBPACK FOOTER //
// ./src/components/Button/index.js